import Sound from '../../Components/Sound/Sound';
import Theme from '../../Components/Theme/Theme';
import Language from '../../Components/Language/Language';
import Button from '../../Components/Button/Button';
import './start.scss';
import { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { preloadHomepage } from './HomepagePreload';
import LanguageContext from '../../Contexts/Language';
import {ReactComponent as Arrow} from '../../Assets/Svg/arrowDown.svg'
import { Checkbox } from '../../Components/Checkbox/Checkbox';

const Start = () =>{
    const {language} = useContext(LanguageContext);
    const navigate = useNavigate();
    const [quality, setQuality] = useState(localStorage.getItem("quality") || "high");

    useEffect(() => {
        const timeout = setTimeout(() => {
            preloadHomepage();
        },1000)
       return () => clearTimeout(timeout)
    }, []);

    useEffect(() =>{
        if(!localStorage.getItem("quality")){
            localStorage.setItem("quality","high");
        }
    },[])

    const changeQuality = () =>{
        setQuality(quality === "low" ? "high" : "low")
        localStorage.setItem("quality",localStorage.getItem("quality") === "low" ? "high" : "low");
    }

    return(
        <div className="start">
            <div className="start-inner">
                <div className="start-header">
                    <p>{language.start.title}</p>
                    <p>Nikita Gwardiak</p>
                    <Checkbox className='low-quality-checkbox' onClick={() =>{changeQuality()}} value={quality}>{language.start.checkbox}</Checkbox>
                </div>
                <Button className="button-wrapper" onClick={() =>{navigate('/homepage')}}>
                    <div className="button-line"><Arrow/></div>
                    <div className='start-button'>{language.start.button}</div>
                </Button>
            </div>
            <Theme/>
            <Sound/>
            <Language/>
        </div>
    )
}
export default Start